module.exports = {
  title: 'Draggable Panel with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2025-07-15',
  slug: 'draggable-panel',
  tags: ['reanimated', 'gesture-handler'],
};
